import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { registerServiceWorkerUpdates } from './utils/serviceWorkerUpdates';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Getting a new build onto a phone that already has an old one is subtle
// enough to deserve its own module, with its own tests — see
// src/utils/serviceWorkerUpdates.ts for the ordering it enforces and why.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void registerServiceWorkerUpdates();
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
